export default __webpack_public_path__ + "static/media/bruce-hamilton-640.f4d31385.jpg";